// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"1346ffa7","769":"0444286d"}[chunkId] + ".chunk.js";
};